




















import { Vue, Component, Prop } from 'vue-property-decorator';
import { HTTP } from '@/services/http-service';

interface IdentityProvider {
  entityId: string;
  name: string;
}

interface IdentityProviderLink {
  url: string;
  name: string;
}

@Component({})
export default class IdentityProviders extends Vue {
  identityProviders: IdentityProviderLink[] = [];

  async mounted() {
    const response = await HTTP.get<IdentityProvider[]>(`public/identityproviders`);

    const apiUrl = window.autoProcessConfiguration.apiUrl;

    this.identityProviders = response.data.map(provider => {
      return {
        name: provider.name,
        url: `${apiUrl}/saml/login?idp=${encodeURIComponent(provider.entityId)}`
      };
    });
  }
}
